var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.Loading),expression:"Loading"}],staticClass:"echarts",attrs:{"element-loading-text":"数据更新中..."}},[_c('div',{attrs:{"id":"echarts"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }